export default {
    jira_summary_name: 'Team Member',
    jira_summary_country: 'Country',
    jira_summary_days_period: 'Days in Period',
    jira_summary_task_period: 'Closed Tasks',
    jira_summary_task_period_gsd: 'Closed Tasks GSD',
    jira_summary_task_period_others: 'Closed Tasks Others',
    jira_summary_total_time_hours: 'Total InProgress',
    jira_summary_total_time_hours_gsd: 'Total InProgress GSD',
    jira_summary_total_time_hours_others: 'Total InProgress Others',
    jira_summary_total_story_points: 'Total Story Points',
    jira_summary_total_story_points_gsd: 'Total Story Points GSD',
    jira_summary_total_story_points_others: 'Total Story Points Others',
    jira_summary_total_rejected_tasks: 'Total Rejected Tasks',
    jira_summary_total_rejections: 'Rejections',
    jira_summary_qa_score: 'QA Score',
    jira_summary_estimation: 'Estimation Score',
    jira_summary_participation: 'Part. Score',
    jira_summary_total: 'Final Score',
    jira_summary_apply_filters: 'Apply filters',
    jira_summary_jira_summary: 'Jira Summary',
    jira_summary_time_frame: 'Time Frame',
    jira_summary_apply: 'Apply',
    jira_summary_bugs_responsible: 'Bugs Responsible',
    jira_summary_total_in_progress_bugs: 'Total InProgress Bugs',
    jira_summary_total_story_points_bugs: 'Total Story Points Bugs',
    jira_summary_closed_tags_bugs: 'Closed Tasks Bugs'
};
